import Box from '@mui/material/Box';
import React from 'react';

export function RichTextEditorLabel({ children }: { children: React.ReactNode }) {
  return <Box sx={{ color: '#666', marginBottom: '8px', marginLeft: '8px' }}>{children}</Box>;
}
